import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';

import { ConfirmDeleteAccount } from '../ConfirmDeleteAccount';

class DeleteAccountPage extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    const {user} = this.props;

    return (
      <div className="col-md-6 col-md-offset-3">


        <div style={{borderRadius: '4px', marginLeft: 'auto', marginRight: 'auto', marginTop: '20px', marginBottom: '20px', backgroundColor: '#fff', border: '1px solid #ccc'}}>
          <div style={{borderBottom: '1px solid #aaa'}} class="uiHeader uiHeaderBottomBorder mhl mts uiHeaderPage interstitialHeader">
            <h2 style={{lineHeight: '20px', minHeight: '20px', paddingBottom: '2px', verticalAlign: 'bottom'}}>Delete My Account</h2>
          </div>
          <div style={{marginBottom: '15px', paddingLeft: '20px', paddingRight: '20px', paddingTop: '10px'}} class="phl ptm uiInterstitialContent"><p style={{margin: '1em 0', display: 'block', marginBefore: '1em', marginAfter: '1em', marginStart: '0px', marginEnd: '0px'}}>If you do not think you will use Fix-a-Drink again, you may delete your account below. Keep in mind that you will not be able to reactivate your account or retrieve any of the content or information you have added.</p><p>If you would still like your account deleted, click "Delete My Account".</p></div>

          <div class="uiInterstitialBar uiBoxGray topborder">
            <div class="clearfix">
              <div class="rfloat _ohf">
                <ConfirmDeleteAccount user={user} /> <NavLink to={'/'}>Get me out of here</NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { authentication } = state;
  const { user } = authentication;
  return {
    user
  };
}

const connectedDeleteAccountPage = connect(mapStateToProps)(DeleteAccountPage);
export { connectedDeleteAccountPage as DeleteAccountPage };


// WEBPACK FOOTER //
// ./src/DeleteAccountPage/DeleteAccountPage.jsx